import { FormEvent, useContext, useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthContext } from './auth-context';
import { AlertI, Button } from './components/Button';
import { InputField } from './components/InputField';
import FBLoginButton from './fb-login-button';
import GoogleLoginButton, { getUriParams } from './google-login-button';
import { login } from './http';
import './login.scss';
import { logLoginEvent } from './util/logLoginEvent';

/* eslint-disable-next-line */
export interface LoginProps {
  submitDisable: boolean;
}

export function Login({ submitDisable }: LoginProps) {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [isRemember, setIsRemember] = useState(true);
  const [alert, setAlert] = useState<AlertI | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(false);
  const navigate = useNavigate();

  const { setAccessToken, setAuthError } = useContext(AuthContext);

  useEffect(() => {
    setDisable(submitDisable);
  }, [submitDisable]);
  useEffect(() => {
    localStorage.setItem('remember', 'true');
    const query = getUriParams();
    if (query && query.start_session) {
      sessionStorage.setItem('access_token', query.start_session);
      // setAccessToken && setAccessToken(query.start_session);
    }
  }, []);

  const handleSubmit = (evt: FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    setLoading(true);

    login(username, password)
      .then((resp) => {
        if (isRemember) {
          localStorage.setItem('remember', 'true');
        } else {
          localStorage.removeItem('remember');
        }

        setLoading(false);
        setAccessToken && setAccessToken(resp.data.access_token);
        logLoginEvent(resp.data.access_token, 'Native');
      })
      .catch((error) => {
        if (error.response.data.reason === 'PASSWORD_EXPIRED') {
          setAuthError && setAuthError(error.response.data.reason);
          navigate('/reset-password');
          return;
        }
        if (error.response.data.reason === 'SUSPICIOUS_LOGIN_ATTEMPTS') {
          setAuthError && setAuthError(error.response.data.reason);
          navigate('/reset-password');
          return;
        }

        setAlert({
          type: 'error',
          message: 'Authentication failed. Please Check your email or password',
        });
        setLoading(false);
      });
  };

  return (
    <section>
      <div className="flex-b">
        <span className="text-left font-size text-gray">Login</span>
        <NavLink to="/signup" className="text-left link text-blue">
          Register
        </NavLink>
      </div>

      <form className="form-container" onSubmit={handleSubmit}>
        <div className="auth-form-group">
          <InputField
            value={username}
            onChange={(e) => {
              setUserName(e.target.value);
              if (alert) {
                setAlert(null);
              }
            }}
            type="text"
            required={true}
            placeholder="Enter your username or email"
          />
        </div>
        <div className="auth-form-group">
          <InputField
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (alert) {
                setAlert(null);
              }
            }}
            required={true}
            placeholder="Enter your password"
            renderIcon={true}
            iconStyle={{
              marginRight: '15px',
              top: '8px',
              right: '5px',
            }}
          />
        </div>
        <div className="auth-form-group flex-b">
          <span className="remember-me-container">
            <input
              className="checkbox"
              type="checkbox"
              defaultChecked
              onChange={(e) => {
                setIsRemember(e.target.checked);
              }}
              name="checkbox"
            />
            <span className="text-black remember-me">Remember me</span>
          </span>
          <button
            className="forgot-pass title-text"
            type="button"
            onClick={() => {
              navigate('reset-password');
            }}
          >
            Forgot password?
          </button>
        </div>
        <div className="auth-form-group">
          <Button type="submit" loading={loading} disabled={disable ? disable : loading} alert={alert}>
            Login
          </Button>
        </div>
      </form>

      <GoogleLoginButton />
      <br />
      <FBLoginButton />
    </section>
  );
}

export default Login;
